export const en = {
    'add-creatives': 'Add selected creatives',
    campaigns: 'Campaigns',
    'campaigns-dropdown-label': 'Used in these campaigns',
    'campaigns-not-found': 'No campaigns found',
    'cancel-and-return': 'Cancel',
    create: 'Use as template',
    'create-new': 'create',
    'get-link-dropdown-label': 'Get a link',
    'items-not-found': "You don't have any creatives yet — go ahead and {presetsLink}",
    preview: 'View',
    'rename-label': 'Rename',
    'search-placeholder': 'Search',
    'show-linked-only': 'Show only creatives used in ads',
    'sound-setting': 'Play audio'
};
